<template>
  <div class="product-card" ref="cardRef" @click="goToProduct(item)">
    <!-- <div v-if="hasDiscount && !lastSale" class="discount-badge">
      
    </div> -->
    <!-- <div v-if="sale && !hasDiscount" class="sale-badge">
    </div> -->
    <div v-if="lastSale" class="last-sale-badge">
      <img
        src="./../assets/img/invoice.png"
        alt="Last Sale"
        class="last-sale-icon"
      />
    </div>

    <div v-if="item?.id === chosenItem" class="added-inscription">
      {{ $t(`Added`) }}
    </div>

    <div class="content-container">
      <div :class="['image-container-full', { isHovered: isHovered }]">
        <div class="image-container">
          <img
            :src="getImageUrl(item)"
            :alt="getTitle(item)"
            class="product-image"
          />
        </div>
      </div>
      <div class="info-container-full">
        <div class="desc product-title">{{ getTitle(item) }}</div>
        <div class="desc product-type">{{ item.type }}</div>

        <div
          class="price-triangle"
          :class="{
            hovered: isHovered,
            'listing-page-triangle': isListingPage,
            'listing-page-triangle-hovered': isListingPage && isHovered,
          }"
        >
          <div class="desc price-text">
            <span>{{ currencySymbol }}</span> {{ item.price }}
          </div>
          <button @click.stop="() => handleClick(item)" class="button">
            {{ $t(`Buy`) }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ProductCard",
  props: {
    item: {
      type: Object,
      required: true,
    },
    currencySymbol: {
      type: String,
      required: true,
    },
    sale: {
      type: Boolean,
    },
    lastSale: {
      type: Boolean,
    },
    isListingPage: {
      type: Boolean,
    },
    chosenItem: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      imgDomain: "",
      isHovered: false,
    };
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
    this.setupHoverListeners();
  },
  beforeUnmount() {
    this.removeHoverListeners();
  },
  computed: {
    ...mapGetters("cart", ["cartContents"]),
    hasDiscount() {
      return this.item && this.item.old_price && this.item.old_price !== "0.00";
    },
  },
  methods: {
    handleClick() {
      this.addToCart(this.item);
    },
    setupHoverListeners() {
      this.$refs.cardRef.addEventListener("mouseenter", this.handleMouseEnter);
      this.$refs.cardRef.addEventListener("mouseleave", this.handleMouseLeave);
    },
    removeHoverListeners() {
      this.$refs.cardRef.removeEventListener(
        "mouseenter",
        this.handleMouseEnter,
      );
      this.$refs.cardRef.removeEventListener(
        "mouseleave",
        this.handleMouseLeave,
      );
    },
    handleMouseEnter() {
      if (!this.isDragging) {
        this.isHovered = true;
      }
    },
    handleMouseLeave() {
      this.isHovered = false;
    },
    goToProduct(item) {
      this.$emit("goToProduct", item);
    },
    getTitle(item) {
      return item.title || item.name;
    },
    getImageUrl(item) {
      return item.item_type === "pack"
        ? item.img_url || item.image_url
        : `${this.imgDomain}${item.img_url}`;
    },
    addToCart(item) {
      const itemAlreadyInCart = this.cartContents.some(
        (cartItem) => cartItem.item_id === item.id,
      );

      if (itemAlreadyInCart) {
        this.$toast.info(this.$t("This item is already in your cart."));
        return;
      }

      this.$emit("addToCart", item);
    },
  },
};
</script>

<style lang="scss" scoped>
.product-card {
  border-radius: 12px;
  background: transparent;
  transition: all 0.3s ease;
  position: relative;
  border: 2px solid #ffffff1a;

  &:hover {
    border-color: #9d1616;
  }
}

.discount-badge,
.sale-badge,
.last-sale-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  align-items: center;
  border-radius: 12px;
  z-index: 2;
}

.discount-icon,
.sale-icon,
.last-sale-icon {
  width: 24px;
  height: 24px;
  pointer-events: none;
}

.product-card .price-triangle {
  margin-top: 10px;
  z-index: 1;
}
.product-card .price-triangle .button {
  margin-top: 20px;
  width: 100%;
  padding: 11px;
}

.price-text {
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: #fff;

  span {
    color: #9d1616;
  }
}

.add-cart-text {
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: #191919;
}

.image-container-full {
  height: 145px;
  object-fit: contain;
  position: relative;
  display: flex;
  padding: 26px 16px;

  &.isHovered::before {
    opacity: 1;
  }
}
.image-container {
  width: 100%;
  max-width: 122px;
  display: flex;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
  user-select: none;
  cursor: pointer;
  position: relative;

  .product-image {
    width: 100%;
    max-width: 100%;
    object-fit: contain;
  }
}
.desc.product-type {
  font-size: 12px;
  color: #fff;
  line-height: 14px;
  opacity: 0.5;
  margin-top: 6px;
}
.info-container-full {
  padding: 0 16px 16px;
}
.filters-and-products .info-container-full {
  padding: 16px;

  .button {
    width: 100%;
  }
}
.added-inscription {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.5);

  color: white;
  padding: 8px 16px;
  border-radius: 4px;
  font-weight: 700;
  font-size: 24px;
  z-index: 10;
}

.content-container {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.product-title {
  font-weight: 700;
  line-height: 14px;
  font-size: 12px;
  height: 14px;
  color: white;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.product-card:hover .product-title {
  text-decoration: underline;
}
</style>
